import script from "./sms-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./sms-form.vue?vue&type=script&setup=true&lang=ts"

import "./sms-form.vue?vue&type=style&index=0&id=075a09e7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-075a09e7"]])

export default __exports__